import { useMutation, useApolloClient } from "@apollo/client";
import useLocalStorage from "react-use-localstorage";
import { useHistory } from "react-router-dom";

import { getUserTypeConfig, UserType } from "../constants/userType";
import { TOKEN, USER_ID, USER_TYPE } from "../constants/session";
import { trackLoginUser, identifyUser } from "../service/analytics";
import createClient from "../apollo";

const useLogin = (userType, redirectUrl) => {
  const { mutation, dataKey, idKey, landing } = getUserTypeConfig(userType);
  const [logIn, { loading }] = useMutation(mutation);
  const setToken = useLocalStorage(TOKEN)[1];
  const setUserId = useLocalStorage(USER_ID)[1];
  const setUserType = useLocalStorage(USER_TYPE)[1];
  const history = useHistory();
  const client = useApolloClient();

  return {
    loading,
    logIn: async (email, password) => {
      trackLoginUser(userType);

      const { data } = await logIn({
        variables: { email, password },
      });

      const {
        [dataKey]: {
          jwt,
          [idKey]: { id, user, firstName, lastName },
        },
      } = data;

      const traits = {
        userType,
        firstName: user?.firstName || firstName,
        lastName: user?.lastName || lastName,
        email: user?.email || email,
      };

      if (userType === UserType.CONSULTANT) {
        const {
          [dataKey]: {
            [idKey]: { address, dateOfBirth, gender },
          },
        } = data;
        traits.country = address.country;
        traits.dateOfBirth = dateOfBirth;
        traits.gender = gender?.title;
      }

      identifyUser(id, traits);

      setToken(jwt);
      setUserId(id);
      setUserType(userType);
      
      localStorage.setItem(TOKEN, jwt);
      localStorage.setItem(USER_ID, id);
      localStorage.setItem(USER_TYPE, userType);
      
      client.setLink(createClient(jwt).link);
      
      history.push(redirectUrl || landing);
    },
  };
};

export default useLogin;
